import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import EmailUpdateUI from './EmailUpdateUI.js'

class EmailUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      errorCode: null,
      // email
      email: this.props.email,
      emailError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <EmailUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        errorCode={this.state.errorCode}
        successMsg={this.state.successMsg}
        // email
        email={this.state.email}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        emailError={this.state.emailError}
        setEmailError={(error) => {this.setState({emailError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/users/${this.props.match.params.userId}/email`,
      this.onSubmitCallback, {
        email: this.state.email,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'email':
          this.setState({emailError: error.message})
          break;
        default:
      }
      if (error.errorCode)
        this.setState({errorCode: error.errorCode})
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let context = this.props.context
    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.AccountUsers(context.session.accountId))
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

}

export default withRouter(EmailUpdateSF)
